// Путь: D:\QR\QR-WEB\dashboard\src\components\Auth\Login.js
// Версия: 3.2.0 - Fixed token/user data extraction
// Дата: 11.12.2025

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './Auth.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://qr-money.onrender.com';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [remember, setRemember] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await axios.post(API_URL + '/api/auth/login', { email, password });
      
      if (res.data.success) {
        // res.data.data.user = JWT токен (строка)
        // res.data.data.token = данные пользователя (объект)
        const jwtToken = res.data.data.token;
        const userData = res.data.data.user;
        
        localStorage.setItem('authToken', jwtToken);
        localStorage.setItem('userId', userData.id);
        localStorage.setItem('userEmail', userData.email);
        localStorage.setItem('userRole', userData.role);
        
        if (onLogin) onLogin(userData);
        
        const role = userData.role;
        if (role === 'admin') {
          navigate('/admin');
        } else if (role === 'business') {
          navigate('/business');
        } else {
          navigate('/dashboard');
        }
      }
    } catch (err) {
      if (err.response?.data?.error === 'EMAIL_NOT_VERIFIED') {
        localStorage.setItem('pendingEmail', email);
        navigate('/verify-email', { state: { email } });
        return;
      }
      setError(err.response?.data?.message || 'Неверный email или пароль');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      {/* Левая часть - информация */}
      <div className="auth-info">
        <div className="auth-info-content">
          <div className="brand">
            <span className="brand-icon">🎁</span>
            <h1 className="brand-name">DARY</h1>
            <p className="brand-tagline">Digital Asset Reward Yours</p>
          </div>
          
          <div className="features">
            <h2>Цифровые подарки нового поколения</h2>
            <p className="features-desc">
              Отправляйте деньги как подарочные карты — красиво, безопасно и мгновенно
            </p>
            
            <ul className="features-list">
              <li>
                <span className="feature-icon">💎</span>
                <div>
                  <strong>Криптовалютные подарки</strong>
                  <span>Создавайте красивые открытки с деньгами внутри</span>
                </div>
              </li>
              <li>
                <span className="feature-icon">🔒</span>
                <div>
                  <strong>Безопасно</strong>
                  <span>Стеганография защищает ваши средства</span>
                </div>
              </li>
              <li>
                <span className="feature-icon">⚡</span>
                <div>
                  <strong>Мгновенно</strong>
                  <span>Отправка и получение за секунды</span>
                </div>
              </li>
              <li>
                <span className="feature-icon">🎨</span>
                <div>
                  <strong>Красиво</strong>
                  <span>12 тематических дизайнов на любой повод</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Правая часть - форма */}
      <div className="auth-form-section">
        <div className="auth-card">
          <div className="auth-card-header">
            <h2>Вход в аккаунт</h2>
            <p>Добро пожаловать! Войдите чтобы продолжить</p>
          </div>
          
          {error && <div className="auth-error">{error}</div>}
          
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label>Ваш email</label>
              <div className="input-wrapper">
                <span className="input-icon">📧</span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                />
              </div>
            </div>
            
            <div className="form-group">
              <label>Ваш пароль</label>
              <div className="input-wrapper">
                <span className="input-icon">🔑</span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
              </div>
            </div>

            <div className="form-options">
              <label className="remember-me">
                <input 
                  type="checkbox" 
                  checked={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                />
                <span>Запомнить меня</span>
              </label>
              <Link to="/forgot-password" className="forgot-link">Забыли пароль?</Link>
            </div>
            
            <button type="submit" disabled={loading} className="btn-submit">
              {loading ? '⏳ Вход...' : 'Войти →'}
            </button>
          </form>
          
          <div className="auth-divider">
            <span>или</span>
          </div>

          <Link to="/register" className="btn-register">
            🚀 Создать аккаунт
          </Link>
          
          <p className="auth-footer">
            Регистрируясь, вы соглашаетесь с <a href="/terms">условиями</a> и <a href="/privacy">политикой конфиденциальности</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
export { Login };
